
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import groupBy from 'lodash/groupBy';

var script = {
  name: 'PendoGuideProgressCell',
  components: {
    PendoIcon,
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  inject: ['$table'],
  props: {
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isShowingAllProgress: false
    };
  },

  computed: {
    toggleAllProgressLabel() {
      if (this.isShowingAllProgress) {
        return 'show less';
      }

      return `+ ${Math.abs(this.row.totalSteps - 9)} more`;
    },

    eventsByStepIndex() {
      if (!this.row.s) {
        return {};
      }

      return groupBy(this.row.s, 'stepIndex');
    },

    visibleStepCount() {
      if (this.isShowingAllProgress) {
        return this.row.totalSteps;
      }

      return Math.min(this.row.totalSteps, 9);
    },

    progress() {
      if (!this.row.s) {
        return;
      }

      return Array.from({
        length: this.visibleStepCount
      }, (x, index) => {
        const stepIndex = index + 1;
        let props;

        if (this.eventsByStepIndex[stepIndex]) {
          const progressEventTypes = ['guideAdvanced', 'guideDismissed', 'guideSnoozed', 'guideSeen', 'guideTimeout'];
          const mostRecentEventForStep = [...this.eventsByStepIndex[stepIndex]].filter(event => progressEventTypes.includes(event.type)).sort((a, b) => b.browserTime - a.browserTime)[0];
          props = {
            guideAdvanced: {
              label: mostRecentEventForStep.isWalkthrough ? 'Advanced' : 'Action Taken',
              fill: '#128297'
            },
            guideDismissed: {
              label: 'Closed',
              fill: '#6A6C75'
            },
            guideSnoozed: {
              label: 'Snoozed',
              fill: '#9A9CA5'
            },
            guideSeen: {
              label: 'Displayed',
              fill: '#128297'
            },
            guideTimeout: {
              label: 'Display Error',
              fill: '#DB1111'
            }
          }[mostRecentEventForStep.type];
        } else {
          props = {
            label: 'Not Seen',
            stroke: '#BABCC5',
            fill: '#FFFFFF'
          };
        }

        return _objectSpread({}, props, {
          tooltip: {
            content: `Step ${stepIndex} of ${this.row.totalSteps}<br/>Status: ${props.label}`,
            html: true,
            arrow: true
          },
          icon: {
            size: 12,
            type: 'circle',
            strokeWidth: 3,
            fill: props.fill,
            stroke: props.stroke || props.fill
          }
        });
      });
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__guide-progress"
  }, [_c('div', {
    staticClass: "pendo-table__guide-progress-container"
  }, _vm._l(_vm.progress, function (step, index) {
    return _c('div', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: step.tooltip,
        expression: "step.tooltip"
      }],
      key: index,
      staticClass: "pendo-table__guide-progress-step"
    }, [_c('pendo-icon', _vm._b({}, 'pendo-icon', step.icon, false))], 1);
  }), 0), _vm._v(" "), _vm.row.totalSteps > 9 ? _c('pendo-button', {
    staticClass: "pendo-table__guide-progress-show-more",
    attrs: {
      "type": "link",
      "label": _vm.toggleAllProgressLabel,
      "size": "mini"
    },
    on: {
      "click": function ($event) {
        _vm.isShowingAllProgress = !_vm.isShowingAllProgress;
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-guide-progress-cell.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoGuideProgressCell = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoGuideProgressCell;
